import { CladdingTypes } from "@object-generators/safety-barrier/objects/cladding";
import { mergeDeep } from "@services/helper.service";
import {
  RESET_CLADDING, 
  SET_CLADDING_STATE, 
  SET_CLADDING_TYPE,
  SET_CLADDING_OPTIONS,
} from "./actions";
import { initState as initDimensionState} from '@reducers/selectors/dimension/index';
import { APP_TYPES } from "@config";

export const initialState = {
  type: CladdingTypes.None,
  depth: 5,
  width: initDimensionState[APP_TYPES.SAFETY_BARRIER].safetyBarrierDimensions.dpot,
  height: initDimensionState[APP_TYPES.SAFETY_BARRIER].safetyBarrierDimensions.hgc,
  offset: {
    top: 25,
    bottom: 25,
    left: 25,
    right: 25
  },
};
 
const cladding = (state = mergeDeep({}, initialState), action) => {
  switch (action.type) {
    case SET_CLADDING_TYPE: {
      return mergeDeep({}, state, {
				type: action.value
      });
    }
    case SET_CLADDING_OPTIONS: {
			return mergeDeep({}, state, action.options);
    }
    case SET_CLADDING_STATE: {
      return action.state;
    }
    case RESET_CLADDING: {
      return mergeDeep({}, initialState);
    }
    default: {
      return state;
    }
  }
};

export default cladding;



// WEBPACK FOOTER //
// ./src/reducers/options/cladding/index.js